import React, { useEffect } from 'react';
import { Button, Grid } from '@material-ui/core';
import Papa from 'papaparse';
import { MODAL_TYPE, useModals } from '../../../../hooks/useModal';
import { exportToCsv } from '../../../../excelExportHelpers';

function AgentListUploader({ reloadUsers, clientId }) {
    const { showModal, currentlyShowingModal } = useModals();

    // reload users list on modal change
    useEffect(reloadUsers, [currentlyShowingModal]);

    const parseCsv = (file, successCallback) => {
        if (!file || !(file instanceof File)) {
            return;
        }
        Papa.parse(file, {
            header: true,
            worker: false,
            skipEmptyLines: 'greedy',
            delimitersToGuess: [',', '\t', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
            complete: ({ data, meta }) => {
                if (
                    meta.fields &&
                    meta.fields.every(field =>
                        ['email', 'password', 'firstname', 'lastname', 'phone'].includes(field)
                    )
                ) {
                    showModal(MODAL_TYPE.ADD_AGENT_LIST, { agents: data, clientId });
                    successCallback();
                }
            }
        });
    };

    return (
        <>
            <Grid item>
                <Button
                    onClick={() => {
                        exportToCsv('sampleagentlist.csv', [
                            ['email', 'password', 'firstname', 'lastname', 'phone'],
                            ['agentupload@activiter.com', 'asdasd', 'Agent', 'Upload', 'phone']
                        ]);
                    }}
                >
                    Agent list sample
                </Button>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => showModal(MODAL_TYPE.ADD_AGENT, { clientId })}
                    id="agent-manual-add"
                >
                    Add agent
                </Button>
            </Grid>
            <Grid item>
                <Button variant="contained" component="label" color="primary">
                    Import agents
                    <input
                        onChange={e => {
                            if (e.target.files.length === 0) {
                                return;
                            }
                            parseCsv(e.target.files[0], () => {
                                e.target.value = '';
                            });
                        }}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        id="agent-list-upload"
                        type="file"
                        hidden
                    />
                </Button>
            </Grid>
        </>
    );
}

export default AgentListUploader;
